import React, { useCallback } from 'react';
import cn from 'classnames';

import { countryReg } from 'app-constants';
import { CheckBox, FlagIcon } from 'components';
import { Action, Category } from 'services/analytics';

import './categorizerCheckRow.scss';

interface Props {
    title: string;
    count: number;
    checked: boolean;
    id: string;
    onClick: (tournamentIds: string[]) => void;
    countryCode?: string | null;
}

const CategorizerCheckRow: React.FC<Props> = ({
    id,
    checked,
    title,
    count,
    countryCode = null,
    onClick,
}) => {
    const handleClick = useCallback(() => {
        onClick([id]);
    }, [onClick, id]);

    return (
        <div
            styleName={cn('row', {
                checked,
            })}
            className="__app-CategorizerCheckRow-row"
            data-category={Category.FiltersCategorizer}
            data-action={Action.SelectTournament}
            onClick={handleClick}
        >
            <CheckBox checked={checked} />

            <div styleName="label" title={title}>
                <span styleName="title">{title.replace(countryReg, '')}</span>
                <FlagIcon countryCode={countryCode} />
            </div>

            <div styleName="counter">{count}</div>
        </div>
    );
};

export default React.memo(CategorizerCheckRow);
